<template>
    <loading v-model:active="isLoding">
        <div class="loader-wrapper">
            <div class="row loader-img">
                <div class="col-12">
                    <!--<img src="../../assets/css/images/loader/loader.png" class="img-fluid" alt="">-->
                    <span class="loader-1"></span>
                    <span class="loader">Load&nbsp;ng</span>
                </div>
            </div>
        </div>
    </loading>
</template>

    <script>
        import Loading from 'vue-loading-overlay';
        import 'vue-loading-overlay/dist/css/index.css';

        export default {
            data() {
            return {
            isLoading: false,
        fullPage: true
            }
        },
        components: {
            Loading
        },
        methods: {
            doAjax() {
            this.isLoading = true;
                // simulate AJAX
                setTimeout(() => {
            this.isLoading = false
        }, 5000)
            },
        onCancel() {
            console.log('User cancelled the loader.')
        }
        }
    }
    </script>
